<template>
    <div class="DebuggingTools">
        <div class="comtent">
            <h2 class="title">智慧停车开放平台接口调试工具</h2>
            <div class="ruleTitle">使用说明：</div>
            <ol class="rules">
                <li>填写相应的参数；</li>
                <li>系统会生成该接口的参数表，您可以直接在文本框内填入对应的参数值。（红色星号表示该字段必填）；</li>
                <li>点击提交按钮，即可得到相应的调试信息；</li>
            </ol>
          <el-row >
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
            <div class="DebuggingToolsMsg">
                <div class="title_P">接口参数：</div>
                <el-form label-position="left" label-width="100px" :model="formData" ref="formData" :rules="rules">
                    <el-form-item label="调试环境：">
                      <el-row :gutter="20">
                      <el-col :span="11">
                        <el-select v-model="interfaceBaseUrl" placeholder="请选择测试地址">
                            <el-option v-if="url.test" label="测试环境" :value="url.test"></el-option>
                            <el-option v-if="url.dev" label="开发环境" :value="url.dev"></el-option>
                            <el-option label="自定义" value=""></el-option>
                        </el-select>
                      </el-col>
                      </el-row>
                    </el-form-item>
                    <el-form-item label="基础Url：" prop="url" v-if="!interfaceBaseUrl">
                        <el-input v-model.trim="customerUrl" placeholder="只需填写基础地址，如：https://openapi-test.xxx.xin"></el-input>
                    </el-form-item>
                    <el-form-item label="调试接口：">
											<!--<div class="flexBox">-->
                        <el-row :gutter="20">
                          <el-col :span="11">
												<el-select v-model="subList" placeholder="请选择测试接口">
                            <!-- <el-option v-for="(item,index) in selectMenuArr" :label="item.name" :value="item.subList" :key="index"></el-option> -->
                            <el-option v-for="(item,index) in selectMenuArr" :label="item.name" :value="index" :key="index"></el-option>

                        </el-select>
                          </el-col>
                          <el-col :span="11">
												<el-select v-model="interfaceUrl" placeholder="请选择测试接口">
                            <el-option v-for="(subItem,index) in subListArr" :label="subItem.name" :value="subItem.value" :key="index"></el-option>
                        </el-select>
                          </el-col>
                        </el-row>
											<!--</div>-->
                    </el-form-item>
                  <el-form-item label="签名方式：">
                    <el-row :gutter="20">
                      <el-col :span="11">
                        <el-select v-model="signType" placeholder="请选择签名方式">
                          <el-option  label="v2" value="v2"></el-option>
                          <el-option  label="v3" value="v3"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </el-form-item>
										<el-form-item label="调试地址：">
											<span style="font-size: 12px">{{formData.url}}</span>
											<!-- <el-input v-model="formData.url"></el-input> -->
                    </el-form-item>
                    <el-form-item label="key：" prop="key">
                        <el-input v-model.trim="formData.key"></el-input>
                    </el-form-item>
                    <el-form-item label="secret：" prop="secret">
                        <el-input v-model.trim="formData.secret"></el-input>
                    </el-form-item>
                    <el-form-item label="body：" prop="body">
                        <el-input :rows="15" type="textarea" v-model.trim="formData.body"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitTest">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
            </el-col>
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
            <div class="responseMsg" v-if="isShowRespose">
                <!-- <img src="../assets/images/libs/ic_service_close.png" alt="" @click="closeShowRespose">
                    <textarea disabled v-model="responseCode">
                    </textarea> -->
                <img src="../assets/images/libs/ic_service_close.png" alt="" @click="closeShowRespose">
                <pre>相关参数：</pre>
                <label>Authorization：{{requestAuth}}</label>
                <label>签名sign：{{requestSign}}</label>
                <label>时间戳ts：{{requestTs}}</label>
                <pre>返回结果：</pre>
                <pre>{{responseCode}}</pre>
            </div>
            </el-col>
          </el-row>
            <!-- <div class="responseMsg" v-if="isShowRespose">
                    <img src="../assets/images/libs/ic_service_close.png" alt="" @click="closeShowRespose">
                    <el-input :rows="22" type="textarea" v-model="responseCode" readonly>
                    </el-input>
                </div> -->
        </div>

        <Foot></Foot>
    </div>
</template>

<script>
import Foot from "../components/Foot.vue";
import axios from "axios";
import common from "../assets/js/common.js";
import md5 from "md5";
import Base64 from "js-base64";
import qs from "qs";
import { mapGetters, mapState, mapMutations } from "vuex";
import { Message } from 'element-ui'
import { isJson } from '@/assets/js/validator';

export default {
  mixins: [common],
  components: {
    Foot: Foot
  },
  beforeRouteEnter(to, from, next) {
    let params = JSON.parse(
      window.localStorage.getItem("DebuggingTools_params")
    );
    console.log("params==params", params);
    next(vm => {
      if (params ? true : false) {
        console.log("直接从文档跳过来的调试");
        let baseUrl = '/openydt/api/v3/'
        let interfaceBaseUrl = params.url.indexOf(baseUrl) >= 0 ? params.url.split(baseUrl)[0] : '';
        let interfaceUrl =
          params.url.indexOf(baseUrl) >= 0 ? (baseUrl + params.url.split(baseUrl)[1]) : params.url;
        vm.formData.url = params.url;
        vm.selectMenuArr.forEach((element, P_index) => {
          element.subList.forEach(subElement => {
            if (subElement.value === interfaceUrl) {
              vm.subList = P_index;
              setTimeout(function() {
                vm.interfaceUrl = interfaceUrl;
                vm.interfaceBaseUrl = interfaceBaseUrl;
                vm.formData.body = params.body;
                window.localStorage.removeItem("DebuggingTools_params");
              }, 200);
              return;
            }
            if(params.upward && subElement.value.indexOf(interfaceUrl) >= 0) {
              vm.subList = P_index;
              setTimeout(function() {
                vm.interfaceUrl = "/" + interfaceUrl;
                vm.interfaceBaseUrl = interfaceBaseUrl;
                vm.formData.body = params.body;
                window.localStorage.removeItem("DebuggingTools_params");
              }, 200);
            }
          });
        });
      }
    });
  },
  data() {
    return {
      interfaceBaseUrl: "https://openapi-test.yidianting.com.cn",
      signType: "v2",
      customerUrl: "",
      interfaceUrl: "",
      subList: "",
      subListArr: "",
      formData: {
        url: "",
        //url: 'http://localhost:8630/openydt/api/v3/getEpt',
        cmd: "",
        key: "",
        secret: "",
        body: ""
      },
      responseCode: "",
      requestAuth: "MTcxdGU0OjIwMTcwOTIxMTEyNTI5",
      requestSign: "454439a799f5b694eb0bcf77d5888a72",
      requestTs: "20170921112529",
      //requestParam: JSON.parse('{"Authorization": "MTcxdGU0OjIwMTcwOTIxMTEyNTI5","sign": "454439a799f5b694eb0bcf77d5888a72","ts": "20170921112529"}',null,4),
      isShowRespose: false,
      rules: {
        url: [{ required: true, message: "请输入调试地址", trigger: "blur" }],
        key: [{ required: true, message: "请输入key参数", trigger: "blur" }],
        secret: [{ required: true, message: "请输入secret参数", trigger: "blur" }],
        body: [
          { required: true, message: "请输入json参数", trigger: "blur" },
          { validator: isJson, message: "请填写正确的JSON格式数据", trigger: "blur" }
          ]
      },
      baseUrl: '/openydt/api/v3/'
    };
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters(["selectMenuArr"]),
    ...mapState(["url"])
  },
  watch: {
    subList: function(val) {
      this.subListArr = this.selectMenuArr[val].subList;
      this.interfaceUrl = this.selectMenuArr[val].subList[0].value;
      // this.interfaceUrl = "";
      if (this.url.test) {
        if (this.formData.url) {
          let url = this.formData.url
          url = url.split(this.baseUrl)[0]
          this.formData.url = url
        } else{
          this.formData.url = this.url.test;
        }
        // this.formData.url = this.url.test;
      } else {
        this.formData.url = this.customerUrl;
      }
    },
    interfaceUrl: function(val) {
      if (this.url.test) {
        if (this.formData.url) {
          let url = this.formData.url
          let uri = url.split('://')[1];
          url = url.indexOf(this.baseUrl) >= 0 || (uri && uri.indexOf('/')) < 0 ? url.split(this.baseUrl)[0] : url.substring(0, url.lastIndexOf('/'))
          this.formData.url = url + val
        } else{
          this.formData.url = this.interfaceBaseUrl + val;
        }
      } else {
        this.formData.url = this.customerUrl + val;
      }
    },
    interfaceBaseUrl: function(val) {
      if (val) {
        this.formData.url = val + this.interfaceUrl;
        this.customerUrl = "";
      } else {
        // this.subList = "";
        this.formData.url = this.customerUrl + this.interfaceUrl;
      }
    },
    customerUrl: function(val) {
      if (val) {
        this.formData.url = val + this.interfaceUrl;
      }
      if (this.customerUrl.indexOf(this.baseUrl) > -1) {
        this.formData.url = this.customerUrl
      }
    }
  },
  created() {
    this.subList = 0;
    if (this.$root.customConfig.url && Object.keys(this.$root.customConfig.url).length > 0) {
      this.setUrl(this.$root.customConfig.url)
    }
    this.interfaceBaseUrl = this.url.test
  },
  methods: {
      ...mapMutations([
        "setUrl"
      ]),
    closeShowRespose() {
      this.isShowRespose = false;
    },
    submitTest() {
      var self = this;
      // this.closeShowRespose();
      this.$refs["formData"].validate(valid => {
        if (valid) {
          if(self.formData.url.indexOf(this.baseUrl) == -1 && (self.formData.url.indexOf(this.url.dev) > -1 ||
              self.formData.url.indexOf(this.url.test) > -1 || self.formData.url.indexOf(this.url.prod) > -1)) {
              Message.warning("请填写贵司正确的基础地址!!!")
              return;
          }
          var date = new Date();
          var ts = this.formatDate(date, "yyyyMMddhhmmss");
          var sign = md5(
            self.formData.key + ":" + ts + ":" + self.formData.secret
          ).toLowerCase();

          if (this.signType === "v3") {
            // 定义时间格式正则表达式
            const timePattern = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/g;

            // 替换时间字符串中的空格为占位符（例如下划线）
            let bodyWithPlaceholder = self.formData.body.replace(timePattern, match => match.replace(' ', '_'));

            // 去除所有空白字符
            let v3Body = bodyWithPlaceholder.replace(/\s+/g, '');

            // 恢复时间字符串中的空格
            v3Body = v3Body.replace(/_/g, ' ');

            sign = md5(
              self.formData.key + ":" + ts + ":" + v3Body + ":" + self.formData.secret
            ).toLowerCase();
          }


          var authorization = Base64.Base64.encode(
            self.formData.key + ":" + ts
          );
          var param = {};
          try {
            param = JSON.parse(self.formData.body);
          } catch (error) {
            Message.warning("请填写正确的JSON格式数据!!")
            return false;
          }
          axios
            .post(self.formData.url + "?sign=" + sign, param, {
              headers: {
                Authorization: authorization,
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers":
                "Authorization,Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,POST",
                "Content-Type": "application/json;charset=utf-8"
              },
              withCredentails: true
            })
            .then(function(res) {
              var data = res.data;
              var root = {};
              self.requestAuth = authorization;
              self.requestSign = sign;
              self.requestTs = ts;
              //self.requestParam = JSON.stringify(root, null, 4);
              self.responseCode = JSON.stringify(data, null, 4);
              self.isShowRespose = true;
            })
            .catch(function(err) {
              Message.warning("请求错误，请检查你的调试地址")
            });
        } else {
          Message.warning("请正确填写必要参数")
          console.log("error valid!!");
          return false;
        }
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../assets/less/var.less";
.DebuggingTools {
  .comtent {
    /*padding: 50px 100px;*/
    /*max-width: 960px;*/
    width: 80%;
    margin: 0 auto;
    .ruleTitle {
      font-family: @contT6;
      font-size: 14px;
      color: #111b29;
    }
    .rules {
      margin: 5px 0 20px 0; // padding-left: 14px;
      .colorR {
        color: red;
      }
      li {
        font-family: @contT3;
        font-size: 14px;
        color: rgba(-2147483648, -2147483648, -2147483648, 0.78);
        line-height: 21px;
      }
    }
    .responseMsg {
      /*margin-top: 10px;*/
      position: relative;
      overflow: hidden;
      img {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }
      pre {
        border: 0px;
        margin: 0px;
        padding: 20px;
        box-sizing: border-box;
        background-color: #0b1935;
        color: white;
        width: 102%;
        max-height: 450px;
        overflow: auto;
      }
      label {
        display: inline-block;
        padding: 10px;
        box-sizing: border-box;
        background-color: #0b1935;
        color: white;
        width: 102%;
      }
    }
    .el-col {
      padding: 0 5px;
    }
    .DebuggingToolsMsg {
      margin-bottom: 10px;
      padding: 20px 50px;
      box-sizing: border-box;
      min-height: 600px;
      background: @bgc;
      border: @bdr;
      .title_P {
        font-family: @contT6;
        font-size: 16px;
        color: #111b29;
        margin-bottom: 20px;
      }
    }
    // input.el-input__inner {
    //   width: 75%;
    // }
    .el-button--primary {
      color: #fff;
      background-color: #20a0ff;
      border-color: #20a0ff;
      float: right;
      padding: 10px 40px;
      &:hover {
        background-color: #4faff3;
      }
    }
  }
}
.el-select-dropdown .el-scrollbar .el-scrollbar__wrap {
  color: #333;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/DebuggingTools.vue